
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 23","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 7.667H0V11.5h3V23h5V11.5h3.6l.4-3.833H8v-1.63c0-.862.2-1.245 1.1-1.245H12V0H8.2C4.6 0 3 1.533 3 4.408v3.259z"}})])
          )
        }
      }
    